export default __webpack_public_path__ + "static/media/Environment.c60e3684.png";